<template>
  <div>
    <CRow>
      <CCol col="12">
        <CCard>
          <CCardHeader>
            <CRow>
              <CCol col="2">
                <strong>{{ $t('FinanceReport') }}</strong>
              </CCol>
              <CCol col="3">
                <CSelect
                    :label="$t('Year')"
                    horizontal
                    :value.sync="selected_year"
                    :options="years_list"
                />

              </CCol>
            </CRow>
          </CCardHeader>
          <CCardBody>
            <CRow>
              <CCol col="3">

                <CSelect
                    :label="$t('tables.type')"
                    horizontal
                    :value.sync="selected_type_parent"
                    :options="types_parent"
                />
              </CCol>

              <CCol col="3">
                <CustomMonthPicker
                    v-model="start_date"
                    :value.sync="start_date"
                />
              </CCol>

              <CCol col="1">
                <CButton @click="get_lists" color="dark"
                         size="sm">
                  <CIcon size="sm" name="cil-zoom"/>
                </CButton>
              </CCol>


            </CRow>
            <CRow v-if="selected_type_parent==4">
              <CCol>
                <CDataTableFixed
                    :items="items_terial_balance"
                    :fields="fields_terial_balance"
                    @row-clicked="table_row_clicked"
                    height="300px"
                    :export_excel="true"
                    :items-per-page="20"
                    hover
                    column-filter
                    border
                    sorter
                >
                  <template #row="{item,index}">
                    <td>
                      <p style="text-align: center">{{ index + 1 }}</p>
                    </td>
                  </template>


                  <template #personCode="{item}">
                    <td>
                      <p style="text-align: center">{{ item.personCode }}</p>
                    </td>
                  </template>
                  <template #personName="{item}">
                    <td>
                      <p>{{ item.personName }}</p>
                    </td>
                  </template>
                  <template #balanceBefore-header>
                      <label style="width: 100%" class="text-center">{{ $t('balanceBefore') }}</label>
                    <label
                        class="double_td_table">{{
                        $t('bedehkar')
                      }}</label>
                    <label
                        class="double_td_table">{{
                        $t('bestankar')
                      }}</label>

                  </template>
                  <template #balanceBefore="{item}">
                    <td>
                      <div style="width: 100%;text-align: right">
                        <label :style="'text-align: right; '+get_style(item,'reminingBefore')"
                               class=""
                               v-if="item.reminingBefore>0">{{
                            get_currency(Math.abs(item.reminingBefore))
                          }}</label>

                        <label style="text-align: right"
                               class=""
                               v-else>0</label>


                      </div>
                    </td>
                    <td>
                      <div style="width: 100%;text-align: right">

                        <label
                            :style="'text-align: right; '+get_style(item,'reminingBefore')"
                            v-if="item.reminingBefore<0"
                            class="">{{
                            get_currency(Math.abs(item.reminingBefore))
                          }}</label>
                        <label
                            style="text-align: right"
                            v-else
                            class="">0</label>


                      </div>
                    </td>
                  </template>
                  <template #AccountCirculation-header>
                    <div>
                      <label class="text-center">{{ $t('AccountCirculation') }}</label>
                    </div>
                    <div>
                      <div style="width: 100%">
                        <label
                            class="double_td_table">{{
                            $t('bedehkar')
                          }}</label>
                        <label
                            class="double_td_table">{{
                            $t('bestankar')
                          }}</label>
                      </div>
                    </div>
                  </template>
                  <template #AccountCirculation="{item}">

                    <td>
                      <div style="width: 100%;text-align: right">

                        <label style="text-align: right"
                               class="">{{
                            get_currency(Math.abs(item.amount))
                          }}</label>
                      </div>
                    </td>
                    <td>
                      <div style="width: 100%;text-align: right">
                        <label style="text-align: right"
                               class="">{{
                            get_currency(Math.abs(item.amountNegetive))
                          }}</label>

                      </div>
                    </td>
                  </template>
                  <template #AccountBalance-header>
                    <div>
                      <label class="text-center">{{ $t('AccountBalance') }}</label>
                    </div>
                    <div>
                      <div style="width: 100%">
                        <label
                            class="double_td_table">{{
                            $t('bedehkar')
                          }}</label>
                        <label
                            class="double_td_table">{{
                            $t('bestankar')
                          }}</label>
                      </div>
                    </div>
                  </template>
                  <template #AccountBalance="{item}">
                    <td>
                      <div style="width: 100%;text-align: right">
                        <label :style="'text-align: right; '+get_style(item,'accBalanceFinal')"
                               class=""
                               v-if="item.accBalanceFinal>0">{{
                            get_currency(Math.abs(item.accBalanceFinal))
                          }}</label>
                        <label style="text-align: right"
                               class=""
                               v-else>0</label>


                      </div>
                    </td>
                    <td>
                      <div style="width: 100%;text-align: right">

                        <label :style="'text-align: right; '+get_style(item,'accBalanceFinal')"
                               v-if="item.accBalanceFinal<0"
                               class="">{{
                            get_currency(Math.abs(item.accBalanceFinal))
                          }}</label>
                        <label style="text-align: right"
                               v-else
                               class="">0</label>
                      </div>
                    </td>
                  </template>
                  <template #caption>
                    <tr class="total-table">
                      <td></td>
                      <td></td>
                      <td></td>
                      <td
                          :style="get_style_trial_balance(calculate_items(items_terial_balance.filter(x=>x.reminingBefore>0),'reminingBefore'),Math.abs(calculate_items(items_terial_balance.filter(x=>x.reminingBefore<0),'reminingBefore')))">
                        {{
                          get_currency(calculate_items(items_terial_balance.filter(x => x.reminingBefore > 0), 'reminingBefore'))
                        }}
                      </td>
                      <td
                          :style="get_style_trial_balance(calculate_items(items_terial_balance.filter(x=>x.reminingBefore>0),'reminingBefore'),Math.abs(calculate_items(items_terial_balance.filter(x=>x.reminingBefore<0),'reminingBefore')))">
                        {{
                          get_currency(Math.abs(calculate_items(items_terial_balance.filter(x => x.reminingBefore < 0), 'reminingBefore')))
                        }}
                      </td>
                      <!--                                            *******************-->
                      <td
                          :style="get_style_trial_balance(calculate_items(items_terial_balance,'amount'),calculate_items(items_terial_balance,'amountNegetive'))">
                        {{ get_currency(calculate_items(items_terial_balance, 'amount')) }}
                      </td>
                      <td
                          :style="get_style_trial_balance(calculate_items(items_terial_balance,'amount'),calculate_items(items_terial_balance,'amountNegetive'))">
                        {{
                          get_currency(calculate_items(items_terial_balance, 'amountNegetive'))
                        }}
                      </td>
                      <!--                                            ******************************-->
                      <td
                          :style="get_style_trial_balance(calculate_items(items_terial_balance.filter(x=>x.accBalanceFinal>0),'accBalanceFinal'),Math.abs(calculate_items(items_terial_balance.filter(x=>x.accBalanceFinal<0),'accBalanceFinal')))">
                        {{
                          get_currency(calculate_items(items_terial_balance.filter(x => x.accBalanceFinal > 0), 'accBalanceFinal'))
                        }}
                      </td>
                      <td
                          :style="get_style_trial_balance(calculate_items(items_terial_balance.filter(x=>x.accBalanceFinal>0),'accBalanceFinal'),Math.abs(calculate_items(items_terial_balance.filter(x=>x.accBalanceFinal<0),'accBalanceFinal')))">
                        {{
                          get_currency(Math.abs(calculate_items(items_terial_balance.filter(x => x.accBalanceFinal < 0), 'accBalanceFinal')))
                        }}
                      </td>
                    </tr>
                  </template>
                </CDataTableFixed>
              </CCol>
            </CRow>
            <CRow v-if="selected_type_parent==19">
              <CCol>
                <CDataTableFixed
                    :items="items_subsidary_balance.filter(x=>x.accBalanceFinal!=0)"
                    :fields="fields_subsidary_balance"
                    @row-clicked="table_row_clicked"
                    height="300px"

                    :items-per-page="20"
                    hover
                    border
                    sorter
                >
                  <template #row="{item,index}">
                    <td>
                      <p style="text-align: center">{{ index + 1 }}</p>
                    </td>
                  </template>


                  <template #personCode="{item}">
                    <td>
                      <p style="text-align: center">{{ item.personCode }}</p>
                    </td>
                  </template>
                  <template #personName="{item}">
                    <td>
                      <p>{{ item.personName }}</p>
                    </td>
                  </template>
                  <template #balanceBefore-header>
                    <div>
                      <label class="text-center">{{ $t('balanceBefore') }}</label>
                    </div>
                    <div>
                      <div style="width: 100%">
                        <label
                            class="double_td_table">{{
                            $t('bedehkar')
                          }}</label>
                        <label
                            class="double_td_table">{{
                            $t('bestankar')
                          }}</label>
                      </div>
                    </div>
                  </template>
                  <template #balanceBefore="{item}">
                    <td>
                      <div style="width: 100%">
                        <label :style="'text-align: right; '+get_style(item,'reminingBefore')"
                               class="double_td_table"
                               v-if="item.reminingBefore>0">{{
                            get_currency(Math.abs(item.reminingBefore))
                          }}</label>

                        <label style="text-align: right"
                               class="double_td_table"
                               v-else>0</label>

                        <label
                            :style="'text-align: right; '+get_style(item,'reminingBefore')"
                            v-if="item.reminingBefore<0"
                            class="double_td_table">{{
                            get_currency(Math.abs(item.reminingBefore))
                          }}</label>
                        <label
                            style="text-align: right"
                            v-else
                            class="double_td_table">0</label>


                      </div>
                    </td>
                  </template>
                  <template #AccountCirculation-header>
                    <div>
                      <label class="text-center">{{ $t('AccountCirculation') }}</label>
                    </div>
                    <div>
                      <div style="width: 100%">
                        <label
                            class="double_td_table">{{
                            $t('bedehkar')
                          }}</label>
                        <label
                            class="double_td_table">{{
                            $t('bestankar')
                          }}</label>
                      </div>
                    </div>
                  </template>
                  <template #AccountCirculation="{item}">

                    <td>
                      <div style="width: 100%">
                        <label v-if="item.amount!=null" style="text-align: right"
                               class="double_td_table">{{
                            get_currency(Math.abs(item.amount))
                          }}</label>

                        <label v-else style="text-align: right"
                               class="double_td_table">0</label>

                        <label v-if="item.amountNegetive!=null" style="text-align: right"
                               class="double_td_table">{{
                            get_currency(Math.abs(item.amountNegetive))
                          }}</label>
                        <label v-else style="text-align: right"
                               class="double_td_table">0</label>

                      </div>
                    </td>
                  </template>
                  <template #AccountBalance-header>
                    <div>
                      <label class="text-center">{{ $t('AccountBalance') }}</label>
                    </div>
                    <div>
                      <div style="width: 100%">
                        <label
                            class="double_td_table">{{
                            $t('bedehkar')
                          }}</label>
                        <label
                            class="double_td_table">{{
                            $t('bestankar')
                          }}</label>
                      </div>
                    </div>
                  </template>
                  <template #AccountBalance="{item}">
                    <td>
                      <div style="width: 100%">
                        <label :style="'text-align: right; '+get_style(item,'accBalanceFinal')"
                               class="double_td_table"
                               v-if="item.accBalanceFinal>0">{{
                            get_currency(Math.abs(item.accBalanceFinal))
                          }}</label>
                        <label style="text-align: right"
                               class="double_td_table"
                               v-else>0</label>

                        <label :style="'text-align: right; '+get_style(item,'accBalanceFinal')"
                               v-if="item.accBalanceFinal<0"
                               class="double_td_table">{{
                            get_currency(Math.abs(item.accBalanceFinal))
                          }}</label>
                        <label style="text-align: right"
                               v-else
                               class="double_td_table">0</label>
                      </div>
                    </td>
                  </template>
                  <template #under-table>
                    <CRow>
                      <CCol></CCol>
                      <CCol></CCol>
                      <CCol></CCol>
                      <CCol></CCol>
                      <CCol :style="get_style_trial_balance(calculate_items(items_subsidary_balance.filter(x=>x.reminingBefore>0),'reminingBefore'),
                                            Math.abs(calculate_items(items_subsidary_balance.filter(x=>x.reminingBefore<0),'reminingBefore')))">
                        {{
                          get_currency(calculate_items(items_subsidary_balance.filter(x => x.reminingBefore > 0), 'reminingBefore'))
                        }}
                      </CCol>
                      <CCol :style="get_style_trial_balance(calculate_items(items_subsidary_balance.filter(x=>x.reminingBefore>0),'reminingBefore'),
                                            Math.abs(calculate_items(items_subsidary_balance.filter(x=>x.reminingBefore<0),'reminingBefore')))">

                        {{
                          get_currency(Math.abs(calculate_items(items_subsidary_balance.filter(x => x.reminingBefore < 0), 'reminingBefore')))
                        }}
                      </CCol>
                      <!--                                            *******************************************-->
                      <CCol :style="get_style_trial_balance(calculate_items(items_subsidary_balance,'amount'),
                                            calculate_items(items_subsidary_balance,'amountNegetive'))">

                        {{
                          get_currency(calculate_items(items_subsidary_balance, 'amount'))
                        }}
                      </CCol>
                      <CCol :style="get_style_trial_balance(calculate_items(items_subsidary_balance,'amount'),
                                            calculate_items(items_subsidary_balance,'amountNegetive'))">

                        {{
                          get_currency(calculate_items(items_subsidary_balance, 'amountNegetive'))
                        }}
                      </CCol>
                      <!--                                            *************************************************-->
                      <CCol :style="get_style_trial_balance(calculate_items(items_subsidary_balance.filter(x=>x.accBalanceFinal>0),'accBalanceFinal'),
                                            Math.abs(calculate_items(items_subsidary_balance.filter(x=>x.accBalanceFinal<0),'accBalanceFinal')))">

                        {{
                          get_currency(calculate_items(items_subsidary_balance.filter(x => x.accBalanceFinal > 0), 'accBalanceFinal'))
                        }}
                      </CCol>
                      <CCol :style="get_style_trial_balance(calculate_items(items_subsidary_balance.filter(x=>x.accBalanceFinal>0),'accBalanceFinal'),
                                            Math.abs(calculate_items(items_subsidary_balance.filter(x=>x.accBalanceFinal<0),'accBalanceFinal')))">

                        {{
                          get_currency(Math.abs(calculate_items(items_subsidary_balance.filter(x => x.accBalanceFinal < 0), 'accBalanceFinal')))
                        }}
                      </CCol>
                    </CRow>
                  </template>

                </CDataTableFixed>
              </CCol>
            </CRow>
            <CRow v-if="selected_type_parent==20">
              <CCol>
                <CDataTableFixed
                    :items="items_ledger_balance.filter(x=>x.accBalanceFinal!=0)"
                    :fields="fields_ledger_balance"
                    @row-clicked="table_row_clicked"
                    height="300px"

                    :items-per-page="20"
                    hover
                    border
                    sorter
                >
                  <template #row="{item,index}">
                    <td>
                      <p style="text-align: center">{{ index + 1 }}</p>
                    </td>
                  </template>


                  <template #personCode="{item}">
                    <td>
                      <p style="text-align: center">{{ item.personCode }}</p>
                    </td>
                  </template>
                  <template #personName="{item}">
                    <td>
                      <p>{{ item.personName }}</p>
                    </td>
                  </template>
                  <template #balanceBefore-header>
                    <div>
                      <label class="text-center">{{ $t('balanceBefore') }}</label>
                    </div>
                    <div>
                      <div style="width: 100%">
                        <label
                            class="double_td_table">{{
                            $t('bedehkar')
                          }}</label>
                        <label
                            class="double_td_table">{{
                            $t('bestankar')
                          }}</label>
                      </div>
                    </div>
                  </template>
                  <template #balanceBefore="{item}">
                    <td>
                      <div style="width: 100%">
                        <label :style="'text-align: right; '+get_style(item,'reminingBefore')"
                               class="double_td_table"
                               v-if="item.reminingBefore>0">{{
                            get_currency(item.reminingBefore)
                          }}</label>

                        <label style="text-align: right"
                               class="double_td_table"
                               v-else>0</label>

                        <label
                            :style="'text-align: right; '+get_style(item,'reminingBefore')"
                            v-if="item.reminingBefore<0"
                            class="double_td_table">{{
                            get_currency(Math.abs(item.reminingBefore))
                          }}</label>
                        <label
                            style="text-align: right"
                            v-else
                            class="double_td_table">0</label>


                      </div>
                    </td>
                  </template>
                  <template #AccountCirculation-header>
                    <div>
                      <label class="text-center">{{ $t('AccountCirculation') }}</label>
                    </div>
                    <div>
                      <div style="width: 100%">
                        <label
                            class="double_td_table">{{
                            $t('bedehkar')
                          }}</label>
                        <label
                            class="double_td_table">{{
                            $t('bestankar')
                          }}</label>
                      </div>
                    </div>
                  </template>
                  <template #AccountCirculation="{item}">

                    <td>
                      <div style="width: 100%">
                        <label v-if="item.amount!=null" style="text-align: right"
                               class="double_td_table">{{
                            get_currency(Math.abs(item.amount))
                          }}</label>

                        <label v-else style="text-align: right"
                               class="double_td_table">0</label>

                        <label v-if="item.amountNegetive!=null" style="text-align: right"
                               class="double_td_table">{{
                            get_currency(Math.abs(item.amountNegetive))
                          }}</label>
                        <label v-else style="text-align: right"
                               class="double_td_table">0</label>

                      </div>
                    </td>
                  </template>
                  <template #AccountBalance-header>
                    <div>
                      <label class="text-center">{{ $t('AccountBalance') }}</label>
                    </div>
                    <div>
                      <div style="width: 100%">
                        <label
                            class="double_td_table">{{
                            $t('bedehkar')
                          }}</label>
                        <label
                            class="double_td_table">{{
                            $t('bestankar')
                          }}</label>
                      </div>
                    </div>
                  </template>
                  <template #AccountBalance="{item}">
                    <td>
                      <div style="width: 100%">
                        <label :style="'text-align: right; '+get_style(item,'accBalanceFinal')"
                               class="double_td_table"
                               v-if="item.accBalanceFinal>0">{{
                            get_currency(Math.abs(item.accBalanceFinal))
                          }}</label>
                        <label style="text-align: right"
                               class="double_td_table"
                               v-else>0</label>

                        <label :style="'text-align: right; '+get_style(item,'accBalanceFinal')"
                               v-if="item.accBalanceFinal<0"
                               class="double_td_table">{{
                            get_currency(Math.abs(item.accBalanceFinal))
                          }}</label>
                        <label style="text-align: right"
                               v-else
                               class="double_td_table">0</label>
                      </div>
                    </td>
                  </template>
                  <template #under-table>
                    <CRow>
                      <CCol></CCol>
                      <CCol></CCol>
                      <CCol></CCol>
                      <CCol></CCol>
                      <!--                                            ***********************************-->
                      <CCol :style="get_style_trial_balance(calculate_items(items_ledger_balance.filter(x=>x.reminingBefore>0),'reminingBefore'),
                                            Math.abs(calculate_items(items_ledger_balance.filter(x=>x.reminingBefore<0),'reminingBefore')))">

                        {{
                          get_currency(calculate_items(items_ledger_balance.filter(x => x.reminingBefore > 0), 'reminingBefore'))
                        }}
                      </CCol>
                      <CCol :style="get_style_trial_balance(calculate_items(items_ledger_balance.filter(x=>x.reminingBefore>0),'reminingBefore'),
                                            Math.abs(calculate_items(items_ledger_balance.filter(x=>x.reminingBefore<0),'reminingBefore')))">

                        {{
                          get_currency(Math.abs(calculate_items(items_ledger_balance.filter(x => x.reminingBefore < 0), 'reminingBefore')))
                        }}
                      </CCol>
                      <!--                                            *****************************************-->
                      <CCol :style="get_style_trial_balance(calculate_items(items_ledger_balance,'amount'),
                                            calculate_items(items_ledger_balance,'amountNegetive'))">

                        {{ get_currency(calculate_items(items_ledger_balance, 'amount')) }}
                      </CCol>
                      <CCol :style="get_style_trial_balance(calculate_items(items_ledger_balance,'amount'),
                                            calculate_items(items_ledger_balance,'amountNegetive'))">

                        {{
                          get_currency(calculate_items(items_ledger_balance, 'amountNegetive'))
                        }}
                      </CCol>
                      <!--                                            ***********************************************-->
                      <CCol :style="get_style_trial_balance(calculate_items(items_ledger_balance.filter(x=>x.accBalanceFinal>0),'accBalanceFinal'),
                                            Math.abs(calculate_items(items_ledger_balance.filter(x=>x.accBalanceFinal<0),'accBalanceFinal')))">

                        {{
                          get_currency(calculate_items(items_ledger_balance.filter(x => x.accBalanceFinal > 0), 'accBalanceFinal'))
                        }}
                      </CCol>
                      <CCol :style="get_style_trial_balance(calculate_items(items_ledger_balance.filter(x=>x.accBalanceFinal>0),'accBalanceFinal'),
                                            Math.abs(calculate_items(items_ledger_balance.filter(x=>x.accBalanceFinal<0),'accBalanceFinal')))">

                        {{
                          get_currency(Math.abs(calculate_items(items_ledger_balance.filter(x => x.accBalanceFinal < 0), 'accBalanceFinal')))
                        }}
                      </CCol>
                    </CRow>
                  </template>

                </CDataTableFixed>
              </CCol>
            </CRow>
            <CRow v-if="selected_type_parent==2">
              <CCol col="8">
                <CDataTableFixed
                    :items="items_profit_loss_balance"
                    :fields="fields_profit_loss_balance"
                    height="300px"

                    :items-per-page="2000"
                    hover
                    border
                >
                  <template #row="{item,index}">
                    <td>
                      <p style="text-align: center">{{ index + 1 }}</p>
                    </td>
                  </template>

                  <template #particulars="{item}">
                    <td>
                      <p :style="get_title_style(item)">{{ item.particulars }}</p>
                    </td>
                  </template>
                  <template #amount="{item}">
                    <td>
                      <p v-if="item.amount!=''" style="text-align: right">
                        {{ currency_with_symbol(Math.abs(item.amount)) }}</p>
                    </td>
                  </template>
                  <template #amount2="{item}">
                    <td v-if="item.amount2>=0">
                      <p v-if="item.amount2!=''" style="text-align: right;font-weight: bold">
                        {{ currency_with_symbol((item.amount2)) }}</p>
                    </td>
                    <td v-if="item.amount2<0">
                      <p v-if="item.amount2!=''" style="text-align: right;font-weight: bold">
                        ({{ currency_with_symbol(Math.abs(item.amount2)) }})</p>
                    </td>
                  </template>

                </CDataTableFixed>
              </CCol>
            </CRow>
            <CRow v-if="selected_type_parent==3">
              <CCol col="8">
                <CDataTableFixed
                    :items="items_balance_sheet_balance"
                    :fields="fields_balance_sheet_balance"
                    height="300px"

                    :items-per-page="2000"
                    hover
                    border
                >
                  <template #row="{item,index}">
                    <td>
                      <p style="text-align: center">{{ index + 1 }}</p>
                    </td>
                  </template>

                  <template #particulars="{item}">
                    <td>
                      <p :style="get_title_style(item)">{{ item.particulars }}</p>
                    </td>
                  </template>
                  <template #amount="{item}">
                    <td>
                      <p v-if="item.amount!=''" style="text-align: right">
                        {{ currency_with_symbol(Math.abs(item.amount)) }}</p>
                    </td>
                  </template>
                  <template #amount2="{item}">
                    <td v-if="item.amount2>=0">
                      <p v-if="item.amount2!=''" style="text-align: right;font-weight: bold">
                        {{ currency_with_symbol((item.amount2)) }}</p>
                    </td>
                    <td v-if="item.amount2<0">
                      <p v-if="item.amount2!=''" style="text-align: right;font-weight: bold">
                        ({{ currency_with_symbol(Math.abs(item.amount2)) }})</p>
                    </td>
                  </template>

                </CDataTableFixed>
              </CCol>
            </CRow>
          </CCardBody>
        </CCard>
      </CCol>
    </CRow>

  </div>
</template>

<script>
import axios from "axios";
import {bus} from '../../../../main';
// import the styles
import Treeselect from '@riophae/vue-treeselect'
// import the styles
import '@riophae/vue-treeselect/dist/vue-treeselect.css'
import {ASYNC_SEARCH} from '@riophae/vue-treeselect'
import moment from 'moment-jalaali'
import CustomMonthPicker from "@/views/panel/includes/CustomMonthPicker";

const simulateAsyncOperation = fn => {
  setTimeout(fn, 200)
}
var items = [];


export default {
  name: 'Login',
  components: {
    Treeselect,
    CustomMonthPicker
  },
  data() {
    return {
      confirm_delete_name: "confirm" + new Date().getTime() + "_" + this.$vnode.tag,
      selected_year: "",
      years_list: [],
      validate_errors: [],
      selected_level: '',
      start_date: '',
      end_date: '',
      types_parent: [],
      selected_type_parent: 0,
      items_terial_balance: [],
      fields_terial_balance: [
        {key: 'row', label: this.$t('tables.row'), sorter: false,filter:false, _style: 'width:5%'},
        {key: 'personCode', label: this.$t('tables.bankAccCode'), _style: 'width:7%'},
        {key: 'personName', label: this.$t('tables.bankAccTitle'), _style: 'width:15%'},
        {
          key: 'balanceBefore',
          label: this.$t('balanceBefore'),
          sorter: false,
          filter:false,
          colspan:2,
          _style: 'width:15%;padding:0px!important'
        },
        {
          key: 'AccountCirculation',
          label: this.$t('AccountCirculation'),
          sorter: false,
          colspan:2,
          filter:false,

          _style: 'width:15%;padding:0px!important'
        },
        {
          key: 'AccountBalance',
          label: this.$t('AccountBalance'),
          sorter: false,
          filter:false,
          colspan:2,

          _style: 'width:15%;padding:0px!important'
        },

        // {key: 'partyName', label: this.$t('bedehkar'), _style: 'width:10%'},
        // {key: 'amount', label: this.$t('bestankar'), _style: 'width:10%'},

        // {key: 'operation', label: this.$t('tables.balance'), _style: 'width:20%;'},
      ],

      items_subsidary_balance: [],
      fields_subsidary_balance: [
        {key: 'row', label: this.$t('tables.row'), sorter: false, _style: 'width:5%'},
        {key: 'personCode', label: this.$t('tables.bankAccCode'), _style: 'width:7%'},
        {key: 'personName', label: this.$t('tables.bankAccTitle'), _style: 'width:10%'},
        {
          key: 'balanceBefore',
          label: this.$t('balanceBefore'),
          sorter: false,
          _style: 'width:15%;padding:0px!important'
        },
        {
          key: 'AccountCirculation',
          label: this.$t('AccountCirculation'),
          sorter: false,
          _style: 'width:15%;padding:0px!important'
        },
        {
          key: 'AccountBalance',
          label: this.$t('AccountBalance'),
          sorter: false,
          _style: 'width:15%;padding:0px!important'
        },

        // {key: 'partyName', label: this.$t('bedehkar'), _style: 'width:10%'},
        // {key: 'amount', label: this.$t('bestankar'), _style: 'width:10%'},

        // {key: 'operation', label: this.$t('tables.balance'), _style: 'width:20%;'},
      ],

      items_ledger_balance: [],
      fields_ledger_balance: [
        {key: 'row', label: this.$t('tables.row'), sorter: false, _style: 'width:5%'},
        {key: 'personCode', label: this.$t('tables.bankAccCode'), _style: 'width:7%'},
        {key: 'personName', label: this.$t('tables.bankAccTitle'), _style: 'width:10%'},
        {
          key: 'balanceBefore',
          label: this.$t('balanceBefore'),
          sorter: false,
          _style: 'width:15%;padding:0px!important'
        },
        {
          key: 'AccountCirculation',
          label: this.$t('AccountCirculation'),
          sorter: false,
          _style: 'width:15%;padding:0px!important'
        },
        {
          key: 'AccountBalance',
          label: this.$t('AccountBalance'),
          sorter: false,
          _style: 'width:15%;padding:0px!important'
        },

        // {key: 'partyName', label: this.$t('bedehkar'), _style: 'width:10%'},
        // {key: 'amount', label: this.$t('bestankar'), _style: 'width:10%'},

        // {key: 'operation', label: this.$t('tables.balance'), _style: 'width:20%;'},
      ],

      items_profit_loss_balance: [],
      fields_profit_loss_balance: [
        {key: 'row', label: this.$t('tables.row'), sorter: false, _style: 'width:3%'},
        {key: 'particulars', label: this.$t('tables.bankAccTitle'), _style: 'width:20%'},
        {key: 'amount', label: this.$t('tables.amount'), _style: 'width:7%'},
        {key: 'amount2', label: this.$t('tables.amount'), _style: 'width:7%'},

      ],

      items_balance_sheet_balance: [],
      fields_balance_sheet_balance: [
        {key: 'row', label: this.$t('tables.row'), sorter: false, _style: 'width:3%'},
        {key: 'particulars', label: this.$t('tables.bankAccTitle'), _style: 'width:20%'},
        {key: 'amount', label: this.$t('tables.amount'), _style: 'width:7%'},
        {key: 'amount2', label: this.$t('tables.amount'), _style: 'width:7%'},

      ],

      status_form: 0,
      table_clicks: 0,
      table_clicks_timer: null,
      searched_person: [],
      document_person: null,
      search_user_async: true,


    }
  },
  created() {
  },
  mounted() {
    this.$root.root_validate_errors = [];
    this.get_years()
    // this.get_lists();
    // if(this.$i18n.locale=="fa"){
    this.start_date = moment().locale(this.$i18n.locale).format('YYYY-MM-DD');
    // }else{
    //   this.start_date = moment().locale(this.$i18n.locale).format('YYYY-MM-DD');
    //
    // }
    this.end_date = this.get_today();
  }, watch: {
    // 'selected_type_parent': function () {
    //     this.get_lists();
    // },
    // 'start_date': function () {
    //     this.get_lists();
    // },

  },
  methods: {
    get_years() {
      var self = this;

      const formData = new FormData();
      // formData.append('id', this.selected_province);
      axios.post('GetFiscalYears', formData, {}).then(function (response) {


        var content_data = response.data;

        // items = content_cats.orders;
        if (content_data.statusCode == 0) {

          self.years_list = self.sort_array([], content_data.data, "id", "title")
          self.selected_year = self.years_list.filter(x => x.isActive == 1)[0].value
          self.get_types()
        }

      }).catch(function (error) {
        console.log(error);
      });

    },
    get_style_trial_balance(item1, item2) {
      var color = '#ff1403';
      item1 = parseFloat(item1).toFixed(2)
      item2 = parseFloat(item2).toFixed(2)
      if (item1 != item2) {

        return 'color:#ff1403;'
      } else {
        return ' '

      }

    },
    get_title_style(item) {
      var style = "";
      if (item.center) {
        style = "text-align:end;"
      }
      if (item.bold) {
        style += "font-weight:bold;"
      }
      return style;
    },
    get_style(item, index) {
      var color = '#ff1403';
      if (item.natureId == 1) {
        if (parseFloat(item[index]) < 0) {
          return 'color:#ff1403;'
        }
      }
      if (item.natureId == 2) {
        if (parseFloat(item[index]) > 0) {
          return 'color:#ff1403;'
        }
      }
      // if (parseFloat(item[index]) < 0) {
      //     // return 'backgroundColor: \'#56ff42\'';
      //     return 'color:#ff1403;'
      // }
    },
    table_row_clicked(item, index) {

      this.table_clicks++;
      if (this.table_clicks == 1) {
        this.table_clicks_timer = setTimeout(() => {
          // this.result.push(event.type);
          this.table_clicks = 0
        }, 500);
      } else if (this.table_clicks > 1) {
        clearTimeout(this.table_clicks_timer);
        this.table_clicks = 0;
        // this.selected_master = item;
        // this.show_factor_detail = true;
        // this.status_form = item.masterId;
        console.log("double clicked", item)
        if (item.accountId == 80) {

          window.open("/dashboard/sale-orders/list-customer/customer-report")

        } else if (item.accountId == 163) {

          window.open("/dashboard/orders/report/supplier-report")

        } else if (item.accountId == 91) {

          window.open("/dashboard/users/employee-report")

        } else {
          window.open("turnover-report/" + item.tafsiliType + "/" + item.personId + "/" + item.personCode + "/" + item.personName + "/" + item.moeinKolGrp + "/" + this.selected_year + "/" + this.start_date)

        }
        // this.$router.push({path:})
        // bus.$emit("finance_report_selected", item);
      }

    },
    get_types() {
      var self = this;


      const formData = new FormData();

      var url = "GetReportNumberList";

      // formData.append('id', "1532");
      axios.post(url, formData, {}).then(function (response) {

        var content_data = response.data;
        // items = content_cats.orders;
        if (content_data.statusCode == 0) {
          var data_get = self.sort_array([], content_data.data
              , "id", "title");
          self.types_all = data_get.filter(x => x.typeId == 1);
          self.types_parent = data_get.filter(x => x.parentId == 0 && x.typeId == 1);
          self.types_parent = self.types_parent.sort(function (a, b) {
            return a.orderNo - b.orderNo
          });

          // self.selected_type_parent = self.types_parent[0].value;
          self.selected_type_parent = 4;
          self.get_lists();

        } else {
          self.$root.modal_component.show_danger_modal(self.$t('dialogs.error'), content_data.message);

        }

      })
          .catch(function (error) {

            console.log(error);
          });

    },

    get_lists() {
      var self = this;

      const formData = new FormData();


      formData.append('Id', this.selected_type_parent);
      // formData.append('PartyType', 2);
      // formData.append('CityId', this.selected_city);
      // formData.append('ProvinceId', this.selected_province);
      // formData.append('RegionId', this.selected_district);
      // formData.append('AreaId', this.selected_area);
      // formData.append('RouteId', this.selected_route);
      var s_year = this.years_list.filter(x => x.value == this.selected_year)[0].label;
      // if(this.$i18n.locale=="fa"){
      //     s_year = parseInt(s_year)+621
      // }
      var start_end_date = this.get_fisrt_last_month(s_year, this.start_date);
//                var s_month = moment(this.start_date).locale(this.$i18n.locale).format("MM");
//               // this.start_date = moment().locale(this.$i18n.locale).format('YYYY-MM-DD');
// console.log('end montj',moment("2023/12/16").locale("fa").endOf('month').format('jYYYY/jMM/jDD'))
//               var date = moment( s_year+ "-" + this.start_date + "-" + "01");
//                 var date2 = moment(s_year + "-" + this.start_date + "-" + "01");
//                 // date.setFullYear(this.selected_year,this.start_date,1);
//                 // date2.setFullYear(this.selected_year,this.start_date,1);
//                 var last_day2 = new Date(date2)
//                 var last_day = new Date(last_day2.getFullYear(), last_day2.getMonth() + 1, 0)

      // moment(date).locale('en').format('YYYY-MM-DD')
      formData.append('FromDate', start_end_date[0]);
      formData.append('ToDate', start_end_date[1]);
      formData.append('YearDate', this.selected_year);
      var url = 'GetAllPersonAccountsMoein';
      if (self.selected_type_parent == 2) {
        url = 'GetProfitStatement';
      }
      if (self.selected_type_parent == 3) {
        url = 'GetBalanceSheetRpt';
      }
      axios.post(url, formData, {}).then(function (response) {

        var content_data = response.data;

        // items = content_cats.orders;
        if (content_data.statusCode == 0) {
          if (self.selected_type_parent == 4) {
            self.items_terial_balance = content_data.data.personAccountItems.map((item, row_id) => {
              return {...item, row_id}
            });
            self.items_terial_balance.forEach(function (val) {
              if (val.natureId == 2) {
                val.accBalanceFinal = (val.reminingBefore - parseFloat(val.amountNegetive)) + parseFloat(val.amount);
              } else {
                val.accBalanceFinal = (val.reminingBefore + parseFloat(val.amount)) - parseFloat(val.amountNegetive);
              }


            })
            // reminingBefore
            // amount
            // amountNegetive
            // accBalance
          }
          if (self.selected_type_parent == 19) {
            self.items_subsidary_balance = content_data.data.personAccountItems.map((item, row_id) => {
              return {...item, row_id}
            });
            self.items_subsidary_balance.forEach(function (val) {
              if (val.natureId == 2) {
                val.accBalanceFinal = (val.reminingBefore - parseFloat(val.amountNegetive)) + parseFloat(val.amount);
              } else {
                val.accBalanceFinal = (val.reminingBefore + parseFloat(val.amount)) - parseFloat(val.amountNegetive);
              }

            })
          }
          if (self.selected_type_parent == 20) {
            self.items_ledger_balance = content_data.data.personAccountItems.map((item, row_id) => {
              return {...item, row_id}
            });
            self.items_ledger_balance.forEach(function (val) {
              if (val.natureId == 2) {
                val.accBalanceFinal = (val.reminingBefore - parseFloat(val.amountNegetive)) + parseFloat(val.amount);
              } else {
                val.accBalanceFinal = (val.reminingBefore + parseFloat(val.amount)) - parseFloat(val.amountNegetive);
              }

            })
          }
          if (self.selected_type_parent == 2) {

            self.items_profit_loss_balance = content_data.data

          }
          if (self.selected_type_parent == 3) {
            self.items_balance_sheet_balance = content_data.data
          }

        } else {
          self.$root.modal_component.show_danger_modal(self.$t('dialogs.error'), content_data.message);

        }

      })
          .catch(function (error) {

            console.log(error);
          });

    },

    goToMembers(item) {

      this.$router.push({path: '/dashboard/accounting/sale-method-members/' + item.id});

    },

    insert_data() {

      if (!this.validateForm()) {
        console.log("validate form is false" + this.validate_errors);
        return true;
      }
      let self = this;
      const formData = new FormData();
      let url;
      if (this.status_form == 0) {
        url = "AddAccountTafsili";
      } else {
        url = "EditAccountTafsili";
        formData.append('Id', this.status_form)

      }


      formData.append('AccountId', this.$route.params.group_id);
      formData.append('PersonId', this.document_person);
      formData.append('LevelNo', this.selected_level);

      // formData.append('AreaId', this.selected_area);
      axios.post(url, formData, {}).then((res) => {


        self.status_form = 0;

        self.document_person = null;
        self.selected_level = '';

        self.get_lists();

        self.$root.modal_component.show_api_response_modals(res);

      })
          .catch(function (error) {

            console.log(error);
          });

    },
    delete_item_dialog(item) {

      this.$root.modal_component.show_confirm_modal(this.$t("dialogs.warning"), this.$t("dialogs.deleteMessage"), [this.$t("dialogs.ok")], 'delete_cash_confirm');

      this.status_form = item.recId;

    }, delete_item() {


      let self = this;
      const formData = new FormData()
      let url;
      url = "DeleteCashPayment";


      formData.append('Id', this.status_form);

      axios.post(url, formData, {}).then((res) => {

        self.$root.modal_component.show_api_response_modals(res);

        self.status_form = 0;

        self.get_lists();


      })
          .catch(function (error) {

            console.log(error);
          });
// this.get_categories();
      // this.$router.push({ path: '/posts/'});
    },

  }
}

</script>
